module.exports = __webpack_public_path__ + "img/slide3.988bf373.png";